// packages
import { jwtDecode } from 'jwt-decode';
// lib
import { getAuthToken } from "./localStorage";
import isEmpty from "./isEmpty";

export const decodeJWT = (token) => {
    try {
        const decoded = jwtDecode(token.replace('Bearer ', ''));
        if (isEmpty(decoded)) {
            return {
                status: false,
                message: 'jwt decode error'
            };
        }
        return {
            status: true,
            decoded
        }
    } catch (err) {
        return {
            status: false,
            message: 'jwt decode error'
        }
    }
}

export const isLogin = () => {
    try {
        let token = getAuthToken();
        if (isEmpty(token)) return { status: false };
        const { status, decoded, message } = decodeJWT(token)
        if (!status) return { status, message };
        return { status, decoded }
    } catch (err) {
        return { status: false };
    }
}